export const COEFFICIENTS = {
  age: -0.0355,
  sex: 0.1593,
  eGFR: -0.0866,
  hemo: -0.0146,
  albuminuriaMild: 0.1321,
  albuminuriaHEavy: 0.7856,
  priorInv: 0.6119
};

export const BASELINES = {
  age: -77.14,
  eGFR: -51.41,
  hemo: -126.74
};

export const FACTOR = {
  conservativeMgmt: 1 / 1.47
};
